import { useQuery, useLazyQuery } from '@apollo/client/react';
export { useQuery, useLazyQuery } from '@apollo/client/react';
export const useSecureFederatedQuery = (query, options = {}) => {
    return useQuery(query, Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, (options.context || {})), { clientName: 'secure' }) }));
};
export const useFederatedQuery = (query, options = {}) => {
    return useQuery(query, Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, (options.context || {})), { clientName: 'external' }) }));
};
export const useFederatedLazyQuery = (query, options = {}) => {
    return useLazyQuery(query, Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, (options.context || {})), { clientName: 'external' }) }));
};
export const useSecureFederatedLazyQuery = (query, options = {}) => {
    return useLazyQuery(query, Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, (options.context || {})), { clientName: 'secure' }) }));
};
export const useInternalFederatedQuery = (query, options = {}) => {
    return useQuery(query, Object.assign(Object.assign({}, options), { context: Object.assign(Object.assign({}, (options.context || {})), { clientName: 'internal' }) }));
};
